(function ($) {
	var PATTERN = '[role="$1"]';

	function rewriteSelector(context, name, argPos) {
		var original = context[name];

		if (!original) return;

		context[name] = function () {
			arguments[argPos] = arguments[argPos].replace(/@([\w\u00c0-\uFFFF\-]+)/g, PATTERN);
			return original.apply(context, arguments);
		};

		$.extend(context[name], original);
	}

	rewriteSelector($, 'find', 0);
	rewriteSelector($, 'multiFilter', 0);
	rewriteSelector($.find, 'matchesSelector', 1);
	rewriteSelector($.find, 'matches', 0);
})(jQuery);

window.app = (function ($) {
	var $documentElement = $('html');

	/* if class is not removed then javascript is disabled */
	$documentElement.removeClass('no-js');

	/* if class is not removed then cookies are disabled */
	if (navigator.cookieEnabled) {
		$documentElement.removeClass('no-cookie');
	}

	return {
		guidEmpty: '00000000-0000-0000-0000-000000000000',
		isGuid: function (guid) {
			return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})+$/.test(guid);
		},
		onLoad: function (cb) {
			var listen = window.addEventListener || window.attachEvent,
				detach = window.removeEventListener || window.detachEvent,
				event = window.addEventListener && 'load' || 'onload';

			var handler = function () {
				detach(event, handler, false);
				cb();
			};

			listen(event, handler);
		}
	};
})(jQuery);